import { useEffect, useState } from "react";
import withRouter from "hoc/withRouter";
import { Alert, Button, Card, CardContent } from "@mui/material";
import AgentsService from "services/admin/AgentsService";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const InstagramOAuth = () => {
  const params = new URLSearchParams(window.location.search);
  const code = params.get("code");
  const state = params.get("state");
  const stateData = JSON.parse(state || "{}");
  console.log("stateData: ", stateData);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const getInstagramAccessToken = async () => {
      try {
        setIsSubmitting(true);
        setError(null);

        if (!code || !stateData) {
          setError("Некорректный код или состояние");
          toast.error("Некорректный код или состояние");
          return;
        }
        if (!stateData.agentID || !stateData.channelConnectionID || !stateData.orgID) {
          setError("Некорректные параметры состояния");
          toast.error("Некорректные параметры состояния");
          return;
        }

        const channelConnectionID = Number(stateData.channelConnectionID);
        const agentID = Number(stateData.agentID);

        const response = await AgentsService.getInstagramToken(channelConnectionID, code, state);
        console.log("response: ", response);

        toast.success("Вход в Instagram выполнен успешно!");

        setTimeout(() => {
          navigate(`/admin/ai-agents/${agentID}/channels/${channelConnectionID}`);
        }, 1500);
      } catch (error: any) {
        console.error("error: ", error);
        setError(error?.message || "Ошибка при входе в Instagram");
        toast.error("Ошибка при входе в Instagram");
      } finally {
        setIsSubmitting(false);
      }
    };
    getInstagramAccessToken();
  }, [code, state]);

  if (isSubmitting) {
    return <div>Выполняется вход в Instagram...</div>;
  }

  return (
    <div>
      <h1>Instagram OAuth</h1>
      <Card>
        <CardContent>
          {error && (
            <div>
              <Alert severity="error">{error}</Alert>
              <div className="w-100 flex justify-center mt-4">
                <Button variant="contained" color="primary" onClick={() => navigate(-1)}>
                  Повторить вход в Instagram
                </Button>
              </div>
            </div>
          )}{" "}
        </CardContent>
      </Card>
    </div>
  );
};

export default withRouter(InstagramOAuth);
